
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.058.038A2.83 2.83 0 003.24 2.856v4.355a.769.769 0 00.768.769.769.769 0 00.769-.769V2.856c0-.717.563-1.28 1.28-1.28h4.794a.769.769 0 00-.044.255v2.05a2.83 2.83 0 002.818 2.818h1.912v8.454c0 .717-.564 1.281-1.281 1.281H6.058c-.718 0-1.281-.564-1.281-1.28v-1.538a.769.769 0 00-.769-.769.769.769 0 00-.768.769v1.537a2.83 2.83 0 002.818 2.818h8.198a2.83 2.83 0 002.818-2.818V5.905a2.818 2.818 0 00-.747-1.912L13.513.945a2.821 2.821 0 00-2.071-.907zm6.286 1.932c.01.01.03.006.04.017l2.812 3.049c.032.035.023.089.05.126h-1.62c-.718 0-1.282-.564-1.282-1.281z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.703 11.567a.769.769 0 010-1.538H9.07L7.308 8.267A.769.769 0 018.394 7.18l3.074 3.074a.769.769 0 010 1.086l-3.074 3.074a.769.769 0 01-1.086-1.086l1.762-1.762z","clip-rule":"evenodd"}})])
          )
        }
      }
    